import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100" style={{ backgroundColor: "#F8F8FB" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>Our Full-Cycle Search Engine Marketing Services</h2>
            <p>
              Whether you’re a startup building your digital brand or an
              established enterprise with a strong online presence, paid
              marketing complements organic reach optimization. Our search
              engine marketing agency offers custom paid campaign management for
              businesses of all sizes to target audiences based on geography and
              user preferences. Enhance your reach and deliver value with
              personalized experiences across relevant channels.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Launch Your Ad Campaign
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>PPC Management</h4>
                  <p>
                    Optimize your ad spend with data-driven strategies and
                    real-time bidding to maximize visibility and conversion
                    rates. Our PPC management ensures cost-effective campaigns
                    that drive quality traffic and ROI.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Search Ads</h4>
                  <p>
                    Capture high-intent users with search ads that appear at the
                    top of SERPs. Tailored keyword targeting and compelling ad
                    copy increase clicks and conversions.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Shopping Ads</h4>
                  <p>
                    Showcase your products with Shopping ads featuring images,
                    prices, and reviews. Engage shoppers directly on SERPs and
                    boost eCommerce sales effectively.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Display Ads</h4>
                  <p>
                    Enhance brand visibility with visually appealing display ads
                    across Google's vast network. Target specific audiences with
                    customized text, images, and video ads.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Remarketing Ads</h4>
                  <p>
                    Re-engage potential customers with remarketing ads that
                    follow them across the web. Increase conversion rates by
                    reminding users of their interest in your products.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Local Service Ads</h4>
                  <p>
                    Connect with local customers through Local Service Ads that
                    appear when users search for services in your area. Drive
                    leads and increase trust with Google’s badge.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Video Ads</h4>
                  <p>
                    Engage audiences with captivating video ads on YouTube and
                    across Google's network. Drive brand awareness and
                    conversions with tailored video content.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>App Promotion Ads</h4>
                  <p>
                    Boost your app’s visibility and downloads with targeted app
                    promotion ads. Reach your audience across search, display,
                    and YouTube platforms efficiently.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
